import { createContext } from 'react';

export const SavedFileContext = createContext("");